import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
import { getFilterTree } from '../utils/tree';
import { isArray } from '../utils/is';
var DefaultValue = {
  data: [],
  filterDelay: 300,
  showHitDescendants: false
};
export default (function (Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Filter, _Component);

    var _super = _createSuper2(Filter);

    function Filter(props) {
      var _this;

      _classCallCheck(this, Filter);

      _this = _super.call(this, props);
      _this.resultCache = void 0;
      _this.timer = void 0;
      _this.state = {
        innerFilter: undefined,
        innerData: undefined,
        filterText: ''
      };
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
      _this.getResultByValues = _this.getResultByValues.bind(_assertThisInitialized(_this));
      _this.resultCache = new Map();
      return _this;
    }

    _createClass(Filter, [{
      key: "getResultByValues",
      value: function getResultByValues() {
        var _this2 = this;

        var _this$props = this.props,
            datum = _this$props.datum,
            noCache = _this$props.noCache,
            renderUnmatched = _this$props.renderUnmatched;
        var value = datum.getValue() || [];
        var vr = isArray(this.props.value) ? this.props.value : [this.props.value];

        if (renderUnmatched) {
          var emptyArr = [];
          value = value.concat(emptyArr.concat(vr).filter(function (v) {
            return v && value.indexOf(v) === -1;
          }));
        }

        var result = [];
        value.forEach(function (v) {
          var res = noCache ? undefined : _this2.resultCache.get(v);

          if (!res) {
            res = datum.getDataById(v);
            if (res && !noCache && !datum.isUnMatch(res)) _this2.resultCache.set(v, res);
          }

          if (res) {
            result.push(res);
          }
        });
        return result;
      }
    }, {
      key: "handleFilter",
      value: function handleFilter(text) {
        var _this3 = this;

        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'edit';
        var _this$props2 = this.props,
            filterDelay = _this$props2.filterDelay,
            onFilter = _this$props2.onFilter; // not filter

        if (!text) {
          this.setState({
            filterText: '',
            innerFilter: undefined,
            innerData: undefined
          });
          if (this.timer) clearTimeout(this.timer);
          if (onFilter) onFilter(text, from);
          return;
        }

        if (!onFilter) return;
        this.setState({
          filterText: text
        });
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          var fn = onFilter(text, from);

          if (typeof fn === 'function') {
            _this3.setState({
              innerFilter: fn
            });
          }
        }, filterDelay);
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        var _this$props3 = this.props,
            _this$props3$data = _this$props3.data,
            data = _this$props3$data === void 0 ? DefaultValue.data : _this$props3$data,
            onFilter = _this$props3.onFilter,
            expanded = _this$props3.expanded,
            _this$props3$showHitD = _this$props3.showHitDescendants,
            showHitDescendants = _this$props3$showHitD === void 0 ? DefaultValue.showHitDescendants : _this$props3$showHitD,
            other = _objectWithoutProperties(_this$props3, ["data", "onFilter", "expanded", "showHitDescendants"]);

        var _this$state = this.state,
            innerFilter = _this$state.innerFilter,
            filterText = _this$state.filterText;
        var filterFn = onFilter ? this.handleFilter : undefined;
        var newData = data;
        var newExpanded = expanded;

        if (innerFilter) {
          var filterExpandedKeys = [];
          newData = getFilterTree(data, innerFilter, filterExpandedKeys, function (node) {
            return _this4.props.datum.getKey(node);
          }, other.childrenKey, showHitDescendants, undefined, {
            advanced: other.onAdvancedFilter
          });
          newExpanded = filterExpandedKeys;
        }

        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, other, {
            filterText: filterText,
            result: this.getResultByValues(),
            data: newData,
            rawData: data,
            onFilter: filterFn,
            expanded: newExpanded
          }))
        );
      }
    }]);

    return Filter;
  }(Component), _class.defaultProps = DefaultValue, _temp;
});